import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Pressure",
    opening: localizedGenderNode(
      [
      "Today I notice the pressure to be perfect.",
      "Just seeing it.",
      "I am here."
    ],
      [
      "Today I notice the pressure to be perfect.",
      "Just seeing it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where is the pressure to be perfect strongest?",
      "What am I afraid will happen if it is not perfect?",
      "Where does it sit in my body?"
    ],
      [
      "Where is the pressure to be perfect strongest?",
      "What am I afraid will happen if it is not perfect?",
      "Where does it sit in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The pressure is an experience, not an identity."
    ],
      [
      "The pressure is an experience, not an identity."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I do not have to be perfect\".",
      "one breath + \"I do not have to be perfect\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The Inner Voice",
    opening: localizedGenderNode(
      [
      "Today I listen to the voice that asks for perfection.",
      "Without fighting it.",
      "I stay with myself."
    ],
      [
      "Today I listen to the voice that asks for perfection.",
      "Without fighting it.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the voice say when it is not perfect?",
      "Which words repeat?",
      "How does it make me feel?"
    ],
      [
      "What does the voice say when it is not perfect?",
      "Which words repeat?",
      "How does it make me feel?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A voice is a voice, not absolute truth."
    ],
      [
      "A voice is a voice, not absolute truth."
    ]
    ),
    action: localizedGenderNode(
      "one sentence - \"This is a voice, not me\".",
      "one sentence - \"This is a voice, not me\"."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Fear Underneath",
    opening: localizedGenderNode(
      [
      "Today I touch the fear beneath perfection.",
      "Gently.",
      "I am here."
    ],
      [
      "Today I touch the fear beneath perfection.",
      "Gently.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my chest.",
      "One breath."
    ],
      [
      "I notice my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of if it is not perfect?",
      "What value am I trying to protect?",
      "What do I need to hear here?"
    ],
      [
      "What am I afraid of if it is not perfect?",
      "What value am I trying to protect?",
      "What do I need to hear here?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear asks for safety, not perfection."
    ],
      [
      "Fear asks for safety, not perfection."
    ]
    ),
    action: localizedGenderNode(
      "say in my heart \"I am safe enough\" once.",
      "say in my heart \"I am safe enough\" once."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Fact vs. Interpretation",
    opening: localizedGenderNode(
      [
      "Today I separate what happened from what I interpret.",
      "Gently.",
      "I am here."
    ],
      [
      "Today I separate what happened from what I interpret.",
      "Gently.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumps in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumps in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Interpretation is not a must."
    ],
      [
      "Interpretation is not a must."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is interpretation\".",
      "an inner sentence - \"This is interpretation\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Cost",
    opening: localizedGenderNode(
      [
      "Today I see the cost of perfection.",
      "Without punishment.",
      "I stay with myself."
    ],
      [
      "Today I see the cost of perfection.",
      "Without punishment.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does perfection take from me?",
      "Where do I get tired?",
      "What would I like to ease?"
    ],
      [
      "What does perfection take from me?",
      "Where do I get tired?",
      "What would I like to ease?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the cost is a gentle step."
    ],
      [
      "Seeing the cost is a gentle step."
    ]
    ),
    action: localizedGenderNode(
      "write one thing I ease today.",
      "write one thing I ease today."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what triggers the need to be perfect.",
      "Just noticing.",
      "I am here."
    ],
      [
      "Today I notice what triggers the need to be perfect.",
      "Just noticing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When does it flare up most?",
      "What situation or person triggers me?",
      "What do I need in that moment?"
    ],
      [
      "When does it flare up most?",
      "What situation or person triggers me?",
      "What do I need in that moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I notice a trigger, I have a small space."
    ],
      [
      "When I notice a trigger, I have a small space."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest when it rises.",
      "a hand on my chest when it rises."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Gentle Boundary",
    opening: localizedGenderNode(
      [
      "Today I set a gentle boundary with perfection.",
      "Not a war.",
      "I am here."
    ],
      [
      "Today I set a gentle boundary with perfection.",
      "Not a war.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where can I lower it by 10%?",
      "What would happen if it were good enough?",
      "What small boundary would help me today?"
    ],
      [
      "Where can I lower it by 10%?",
      "What would happen if it were good enough?",
      "What small boundary would help me today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary creates space to breathe."
    ],
      [
      "A small boundary creates space to breathe."
    ]
    ),
    action: localizedGenderNode(
      "say \"good enough\" once.",
      "say \"good enough\" once."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Compassion",
    opening: localizedGenderNode(
      [
      "Today I try to speak to myself gently.",
      "Even if it is new.",
      "I am here."
    ],
      [
      "Today I try to speak to myself gently.",
      "Even if it is new.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What shifts in me when I hear it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One gentle word is enough to begin."
    ],
      [
      "One gentle word is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Being Enough",
    opening: localizedGenderNode(
      [
      "Today I touch the idea of \"enough\".",
      "Without pushing.",
      "I am here."
    ],
      [
      "Today I touch the idea of \"enough\".",
      "Without pushing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I hear my breath.",
      "One breath."
    ],
      [
      "I hear my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What looks like \"enough\" today?",
      "How does it feel if I let it be?",
      "What do I gain from that?"
    ],
      [
      "What looks like \"enough\" today?",
      "How does it feel if I let it be?",
      "What do I gain from that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Enough is a new experience I am learning."
    ],
      [
      "Enough is a new experience I am learning."
    ]
    ),
    action: localizedGenderNode(
      "choose one thing to be enough.",
      "choose one thing to be enough."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Request to Myself",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften the day."
    ],
      [
      "One request can soften the day."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Shift",
    opening: localizedGenderNode(
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ],
      [
      "Today I choose a small shift within the day.",
      "Not a revolution.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice one point of contact in my body.",
      "One breath."
    ],
      [
      "I notice one point of contact in my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ],
      [
      "What small shift am I willing to try today?",
      "When is it easiest to try it?",
      "What will gently remind me to choose it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small shift is a gentle movement."
    ],
      [
      "A small shift is a gentle movement."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment to try it.",
      "choose one moment to try it."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Being Human",
    opening: localizedGenderNode(
      [
      "Today I make space for being human.",
      "Without dismissing it.",
      "I am here."
    ],
      [
      "Today I make space for being human.",
      "Without dismissing it.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would happen if I allowed myself to be human?",
      "What would that release in me?",
      "What gentleness can I give myself?"
    ],
      [
      "What would happen if I allowed myself to be human?",
      "What would that release in me?",
      "What gentleness can I give myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being human is not a failure."
    ],
      [
      "Being human is not a failure."
    ]
    ),
    action: localizedGenderNode(
      "one permission sentence to myself.",
      "one permission sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Practice",
    opening: localizedGenderNode(
      [
      "Today I choose a small practice that softens perfection.",
      "Simple.",
      "I am here."
    ],
      [
      "Today I choose a small practice that softens perfection.",
      "Simple.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small practice could help me today?",
      "When in the day do I do it?",
      "What will gently remind me?"
    ],
      [
      "What small practice could help me today?",
      "When in the day do I do it?",
      "What will gently remind me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small practice creates a gentle change."
    ],
      [
      "A small practice creates a gentle change."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment for the practice.",
      "choose one moment for the practice."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ],
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about my perfection?",
      "What is the early sign I return to the pressure?",
      "Return sentence for the moment before - what do I say to myself?"
    ],
      [
      "What did I learn about my perfection?",
      "What is the early sign I return to the pressure?",
      "Return sentence for the moment before - what do I say to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can be accurate without being perfect."
    ],
      [
      "I can be accurate without being perfect."
    ]
    ),
    action: localizedGenderNode(
      "one breath before responding.",
      "one breath before responding."
    ),
  },
].map(buildNormalizedDay);

export const needToBePerfectInEverythingBlueprintEn = buildNormalizedPilotBlueprint({
  id: "need_to_be_perfect_in_everything_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "need_to_be_perfect_in_everything",
  category: "self_worth",
  journeyName: {
    he: "פרפקציוניזם (יכול להיות מושלם בהכל)",
    en: "Need to be perfect in everything",
    es: "Necesidad de ser perfecto/a en todo",
  },
  days,
});

export default needToBePerfectInEverythingBlueprintEn;
